import Colors from '@shared/assets/style/default/color';
import ScreenUtils from '@shared/utils/screen';
import styled from 'styled-components';

const TopBarPlan = styled.span<{ color?: string }>`
  align-self: center;
  color: ${(props) => (props.color ? props.color : Colors['light'])};
  margin-left: ${16 * ScreenUtils.widthRatio}px;
`;

export default TopBarPlan;
